<script lang="ts">

    export let styles:string = '';
    export let loading:boolean = false;
    export let mode:string = 'default';

    let colorClasses = 'bg-hand-purple-500 hover:bg-hand-purple-600 text-white';
    switch(mode) {
        case 'danger':
            colorClasses = 'bg-red-600 hover:bg-red-500 text-white';
            break;
        case 'secondary':
            colorClasses = 'bg-gray-50 border border-gray-200 text-gray-800';
            break;
    }
</script>

<button class="{colorClasses} w-auto px-4 py-3 rounded-lg font-medium {styles}" disabled={loading} {...$$restProps} on:click|preventDefault on:mouseover on:mouseenter on:mouseleave on:keyup on:keydown on:focus on:blur>
    {#if !loading}
        <slot />
    {:else}
        <svg class="animate-spin mx-auto h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    {/if}
</button>